import React from "react";
import Popup from "../../../../../components/Popup";
import partnerServices from '../../../../../services/admFin/partnerServices';

export function PartnerInfoPopUp(props) {
    return(
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            tittle={partnerServices.partnerServiceType[props.parceria][1]}
            icon={props.icon}
        >
            <div className="records-element-info">
                <h4><b>{props.partner && props.partner.nome ? props.partner.nome : ""}</b></h4>
                <p><b>Pessoa {props.partner.tipo ? partnerServices.partnerType[props.partner.tipo][1]: ""}</b></p>
                <p><b>Documento: </b>{props.partner.documento}</p>
                <p><b>Cep: </b>{props.partner.cep}</p>
                <p><b>Estado: </b>{props.partner.estado}</p>
                <p><b>Cidade: </b>{props.partner.cidade}</p>
                <p><b>Logradouro: </b>{props.partner.logradouro}</p>
            </div>
        </Popup>
)
}